interface CrmContactDeleteConfirmDialogProps {
  displayName: string;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function CrmContactDeleteConfirmDialog({
  displayName,
  isDeleting,
  onCancel,
  onConfirm,
}: CrmContactDeleteConfirmDialogProps) {
  return (
    <>
      <div className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-[4px]" onClick={onCancel} />
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
        <div className="w-full max-w-sm rounded-xl border border-[var(--color-border)] bg-[var(--color-card)] p-6 shadow-xl animate-in zoom-in-95 fade-in duration-200">
          <h3 className="text-lg font-semibold text-[var(--color-foreground)]">Delete {displayName}?</h3>
          <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">
            This cannot be undone. All contact data, tags, and timeline entries will be permanently deleted.
          </p>
          <div className="mt-4 flex justify-end gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="rounded-lg px-4 py-2 text-sm font-medium text-[var(--color-muted-foreground)] transition-colors hover:bg-[var(--color-muted)] hover:text-[var(--color-foreground)]"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isDeleting}
              className="btn-press rounded-lg bg-[var(--color-destructive)] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[var(--color-destructive)]/90 disabled:opacity-50"
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
